import { Radio, Checkbox, FgInput, Button, Dropdown, Card, Pagination, PhoneNumber } from '@/components/UIComponents'
import { Select, Option, Table, TableColumn, Input, TimeSelect, Upload, Popover } from 'element-ui'
import AsyncWrapper from 'Shared/Wrappers/AsyncWrapper'
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

const GlobalComponents = {
    install(Vue) {
        Vue.component(FgInput.name, FgInput)
        Vue.component(Dropdown.name, Dropdown)
        Vue.component(Checkbox.name, Checkbox)
        Vue.component(Radio.name, Radio)
        Vue.component(Button.name, Button)
        Vue.component(Card.name, Button)
        Vue.component(Select.name, Select)
        Vue.component(Table.name, Table)
        Vue.component(Pagination.name, Pagination)
        Vue.component(TableColumn.name, TableColumn)
        Vue.component(Input.name, Input)
        Vue.component(Option.name, Option)
        Vue.component(TimeSelect.name, TimeSelect)
        Vue.component(Upload.name, Upload)
        Vue.component(AsyncWrapper.name, AsyncWrapper)
        Vue.component(PhoneNumber.name, PhoneNumber)
        Vue.component(Popover.name, Popover)
    }
}

export default GlobalComponents
